export default __webpack_public_path__ + "10ecefc282f2761808bf26cb335511d5.ttf";